module.exports = __webpack_public_path__ + "img/crema o unguento oftalmico.22ab14eb.png";